import { defineMessages } from 'react-intl';

export default defineMessages({
  logout: {
    id: 'view.header.logout',
    defaultMessage: 'Log out',
  },
  en: {
    id: 'view.changeLanguage.en',
    defaultMessage: 'English',
  },
  fr: {
    id: 'view.changeLanguage.fr',
    defaultMessage: 'Français',
  },
  es: {
    id: 'view.changeLanguage.es',
    defaultMessage: 'Español',
  },
  de: {
    id: 'view.changeLanguage.de',
    defaultMessage: 'Deutsch',
  },
  it: {
    id: 'view.changeLanguage.it',
    defaultMessage: 'Italian',
  },
  pt: {
    id: 'view.changeLanguage.pt',
    defaultMessage: 'Portuguese',
  },
  nl: {
    id: 'view.changeLanguage.nl',
    defaultMessage: 'Dutch',
  },
  languageLabel: {
    id: 'view.header.languageLabel',
    defaultMessage: 'Language',
  },
});
